<!--
	描述：日期选择弹窗
-->
<template>
	<div class="pickerBody" @mouseleave="showPicker = false,nowDate = tempDate" @mouseenter="tempDate = nowDate" @click.stop="showPicker = true">
		<div class="pickerTitle">
			<img :src="icon" />
			<span>{{getTextMethod(nowDate)}}</span>
		</div>
		<div class="pickerInfo" v-show="showPicker">
			<table class="datepicker" v-show="['date','dateTime'].includes(dateType)" cellspacing="15">
				<tr>
					<td @click="nowYear--">&#60;&#60;</td>
					<td @click="monthadd(-1)">&#60;</td>
					<td colspan="3">{{this.nowYear}}年{{this.nowMonth +1}}月</td>
					<td @click="monthadd(1)">&#62;</td>
					<td @click="nowYear++">&#62;&#62;</td>
				</tr>
				<tr>
					<td>日</td>
					<td>一</td>
					<td>二</td>
					<td>三</td>
					<td>四</td>
					<td>五</td>
					<td>六</td>
				</tr>
				<tr v-for="(tr,trIndex) in dayTrList" :key="trIndex" class="dateTd">
					<td v-for="(td,tdIndex) in tr" :key="tdIndex" :class="{notThisMonth:!td.inThisMonth,isToday:td.isToday,isCheck:td.isCheck}"
					 @click.stop="isChecked = true,checkDay(td)">{{td.day}}</td>
				</tr>
			</table>
			<div class="timePicker" v-if="['dateTime'].includes(dateType)">
				<ul class="hideBar">
					<li v-for="item in 24" :class="{isCheck:item-1==nowHour}" @click.stop="nowHour=item-1">{{item-1}}</li>
				</ul>
				<span>:</span>
				<ul class="hideBar">
					<li v-for="item in 60" :class="{isCheck:item-1==nowMinute}" @click.stop="nowMinute=item-1">{{item-1}}</li>
				</ul>
				<span>:</span>
				<ul class="hideBar">
					<li v-for="item in 60" :class="{isCheck:item-1==nowSecond}" @click.stop="nowSecond=item-1">{{item-1}}</li>
				</ul>
			</div>
			<p class="nomalButton" @click.stop="tempDate = nowDate,showPicker = false,isChecked = true,$emit('checkDate', nowDate)" v-if="['dateTime'].includes(dateType)">确定</p>
		</div>
	</div>
</template>

<script type="text/javascript">
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		name: '',
		components: {},
		props: {
			initDate: {
				type: Date
			},
			dateType: {
				validator(value) {
					return ['date', 'month', 'year', 'dateTime'].includes(value)
				},
				default: 'date'
			},
			getTextMethod: {
				type: Function,
				default (nowDate) {
					if (nowDate == undefined || !this.isChecked) {
						return "点击选择日期"
					}
					switch (this.dateType) {
						case 'date':
							return nowDate.formatByDate()
						case 'month':
							return nowDate.formatByMonth()
						case 'year':
							return nowDate.getFullYear()
						case 'dateTime':
							return nowDate.formatByTime()
					}
					return ""
				}
			}
		},
		data() {
			return {
				showPicker: false,
				nowDate: new Date(),
				nowYear: 0,
				nowMonth: 0,
				nowDay: 0,
				nowHour: 0,
				nowMinute: 0,
				nowSecond: 0,
				tempDate: undefined,
				//如果没有预置初始日期，则不会触发选中事件
				isChecked:false
			}
		},
		created() {},
		mounted() {
			
			if (this.initDate != undefined) {
				this.nowDate = this.initDate
				this.isChecked = true
			}
			this.nowYear = this.nowDate.getFullYear()
			this.nowMonth = this.nowDate.getMonth()
			this.nowDay = this.nowDate.getDate()
			this.nowHour = this.nowDate.getHours()
			this.nowMinute = this.nowDate.getMinutes()
			this.nowSecond = this.nowDate.getSeconds()
		},
		destroyed() {},
		computed: {
			icon() {
				return resourcesStore.getters.getResourcesByName('wedoButton/date.png')
			},
			thisMonthStartTime() {
				//本月开始时间
				return new Date(this.nowYear, this.nowMonth, 1).getTime()
			},
			thisMonthEndTime() {
				//本月结束时间
				return new Date(this.nowYear, this.nowMonth + 1, 1).getTime() - 1
			},
			dayTrList() {
				var dayTrList = []
				var day = new Date(this.thisMonthStartTime).getDay()
				var temp = []
				//这是上个月的日期
				var startDay = undefined
				for (var i = 0; i < day; i++) {
					if (startDay == undefined) {
						startDay = new Date(this.thisMonthStartTime - (day - i) * 24 * 60 * 60 * 1000).getDate()
					}
					temp.push({
						year: this.nowMonth - 1 < 0 ? this.nowYear - 1 : this.nowYear,
						month: this.nowMonth - 1 < 0 ? 11 : this.nowMonth - 1,
						inThisMonth: false,
						day: startDay++
					})
				}
				//这个月的日期
				startDay = 1
				for (var i = this.thisMonthStartTime, end = this.thisMonthEndTime; i < end; i += 24 * 60 * 60 * 1000) {
					temp.push({
						year: this.nowYear,
						month: this.nowMonth,
						inThisMonth: true,
						day: startDay++
					})
					if (temp.length >= 7) {
						dayTrList.push(temp)
						temp = []
					}
				}
				//看看需要下一个月的日期不
				startDay = 1
				if (dayTrList.length < 6 || temp.length != 0) {
					do {
						for (var i = 1, end = 7 - temp.length; i <= end; i++) {
							temp.push({
								year: this.nowMonth + 1 > 11 ? this.nowYear + 1 : this.nowYear,
								month: this.nowMonth + 1 > 11 ? 0 : this.nowMonth + 1,
								inThisMonth: false,
								day: startDay++
							})
						}
						dayTrList.push(temp)
						temp = []
					} while (dayTrList.length < 6)
				}
				//找到今天和当前选择的日期
				var today = new Date()
				var tY = today.getFullYear()
				var tM = today.getMonth()
				var tD = today.getDate()
				var nY = this.nowDate.getFullYear()
				var nM = this.nowDate.getMonth()
				var nD = this.nowDate.getDate()
				for (var i = 0, len = dayTrList.length; i < len; i++) {
					var tr = dayTrList[i]
					for (var j = 0, len2 = tr.length; j < len2; j++) {
						var td = tr[j]
						td.isToday = td.year == tY && td.month == tM && td.day == tD
						td.isCheck = td.year == nY && td.month == nM && td.day == nD
					}

				}
				return dayTrList
			},
		},
		watch: {
			nowHour(nv, ov) {
				this.nowDate.setHours(nv)
			},
			nowMinute(nv, ov) {
				this.nowDate.setMinutes(nv)
			},
			nowSecond(nv, ov) {
				this.nowDate.setSeconds(nv)
			},
		},
		methods: {
			monthadd(num) {
				this.nowMonth += num
				if (this.nowMonth > 11) {
					this.nowMonth = 0
					this.nowYear++
				}
				if (this.nowMonth < 0) {
					this.nowMonth = 11
					this.nowYear--
				}
			},
			checkDay(td) {
				this.nowDate = new Date(td.year, td.month, td.day, this.nowDate.getHours(), this.nowDate.getMinutes(), this.nowDate
					.getSeconds())
				//如果是没显示时间的，就直接关闭和回调
				if (this.dateType != 'dateTime') {
					this.tempDate = this.nowDate
					this.$emit("checkDate", this.nowDate)
					this.showPicker = false
				}
			},
			setDateTime(dateBean){
				this.nowDate = dateBean
				this.$emit("checkDate", this.nowDate)
			}
		}
	}
</script>

<style scoped>
	.pickerBody {
		border: .01rem solid #CCCCCC;
		border-radius: 5px;
		padding: .03rem .05rem;
		display: inline-block;
		background: white;
		color: black;
		min-width: 153px;
		height: .2rem;
		position: relative;
	}

	.pickerTitle {
		cursor: pointer;
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
	}

	.pickerTitle>img {
		width: .15rem;
		height: .15rem;
		margin-right: .1rem;
	}

	.timePicker {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 .25rem;
	}

	.timePicker>ul {
		width: .6rem;
		height: 1rem;
		overflow: auto;
		background: white;
		border: silver 1px solid;
		border-radius: 5px;
	}

	.timePicker>ul>li {
		text-align: center;
		color: black;
		cursor: pointer;
	}

	.timePicker>ul>li.isCheck,.timePicker>ul>li:hover {
		color: white;
		background: skyblue;
	}
	
	.pickerInfo {
		background: white;
		min-width: 2rem;
		position: absolute;
		top: .27rem;
		left: 0;
		padding: .1rem;
		z-index: 100;
		border-radius: 5px;
		border:silver solid 1px;
	}
	.pickerInfo td {
		min-width: .25rem;
		height: .25rem;
		text-align: center;
		cursor: pointer;
	}

	.dateTd td:hover {
		background: #20A0FF;
		border-radius: 100%;
		color: white;
	}

	td.notThisMonth {
		color: gray;
	}

	td.isToday {
		color: white;
		background: green;
		border-radius: 100%;
	}

	td.isCheck {
		color: white;
		background: #20A0FF;
		border-radius: 100%;
	}

	p.nomalButton {
		margin-top: .2rem;
		padding: .1rem;
		display: block;
	}

</style>
